(function () {
  'use strict';

  var Theme = window.Theme || {};
  var designMode = !!(window.Shopify && window.Shopify.designMode);

  // ── Utilities ──
  function $(sel, scope) { return (scope || document).querySelector(sel); }
  function $$(sel, scope) { return Array.from((scope || document).querySelectorAll(sel)); }

  function formatMoney(cents) {
    try {
      return new Intl.NumberFormat(Theme.shop && Theme.shop.locale || 'en', {
        style: 'currency',
        currency: Theme.shop && Theme.shop.currency || 'USD'
      }).format((cents || 0) / 100);
    } catch (e) {
      return '$' + ((cents || 0) / 100).toFixed(2);
    }
  }

  function showToast(msg) {
    var t = $('.toast');
    if (!t) return;
    t.textContent = msg;
    t.hidden = false;
    setTimeout(function () { t.hidden = true; }, 2400);
  }

  // ── Mobile menu ──
  function initMobileMenu(scope) {
    var burger = $('[data-mobile-menu-toggle]', scope);
    var drawer = $('[data-mobile-menu]', scope);
    if (!burger || !drawer) return;
    burger.addEventListener('click', function () {
      var open = drawer.classList.toggle('is-open');
      document.body.style.overflow = open ? 'hidden' : '';
      burger.setAttribute('aria-expanded', String(open));
    });
    $$('[data-mobile-menu-close]', scope).forEach(function (el) {
      el.addEventListener('click', function () {
        drawer.classList.remove('is-open');
        document.body.style.overflow = '';
        burger.setAttribute('aria-expanded', 'false');
      });
    });
  }

  // ── Cart drawer ──
  function openCart() {
    var d = $('[data-cart-drawer]');
    if (!d) return;
    d.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }
  function closeCart() {
    var d = $('[data-cart-drawer]');
    if (!d) return;
    d.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  function initCartDrawerEvents() {
    $$('[data-cart-drawer-open]').forEach(function (el) {
      el.addEventListener('click', function (e) { e.preventDefault(); openCart(); });
    });
    $$('[data-cart-drawer-close]').forEach(function (el) {
      el.addEventListener('click', function (e) { e.preventDefault(); closeCart(); });
    });
  }

  function fetchCartJson() {
    return fetch(Theme.routes.cart_url + '.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }

  function renderCartDrawer() {
    if (!Theme.routes) return Promise.resolve();
    return fetchCartJson().then(function (cart) {
      // Update subtotal
      var subtotalEl = $('[data-cart-subtotal]');
      if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
      // Update count badges
      $$('[data-cart-count]').forEach(function (el) {
        el.textContent = cart.item_count;
        el.hidden = cart.item_count === 0;
      });
      // Re-render items list
      var body = $('[data-cart-drawer-body]');
      if (!body) return;
      if (cart.item_count === 0) {
        body.innerHTML = '<p class="cart-drawer__empty">Your cart is empty.</p>';
        return;
      }
      var html = '<ul class="cart-drawer__items" data-cart-items>';
      cart.items.forEach(function (item) {
        var img = item.featured_image && item.featured_image.url
          ? '<img src="' + item.featured_image.url + '?width=160" alt="' + (item.title || '') + '" width="80" height="80" loading="lazy">'
          : '<div class="placeholder-image"></div>';
        var variantTitle = item.variant_title !== 'Default Title' ? '<small>' + item.variant_title + '</small>' : '';
        html += '<li class="cart-line" data-line-key="' + item.key + '">'
          + '<div class="cart-line__img">' + img + '</div>'
          + '<div class="cart-line__info">'
          + '<a href="' + item.url + '">' + item.product_title + '</a>'
          + variantTitle
          + '<div class="cart-line__qty">'
          + '<button type="button" data-qty-minus aria-label="Decrease">&minus;</button>'
          + '<input type="number" min="0" value="' + item.quantity + '" data-qty aria-label="Quantity">'
          + '<button type="button" data-qty-plus aria-label="Increase">+</button>'
          + '</div>'
          + '<button type="button" class="cart-line__remove" data-remove>Remove</button>'
          + '</div>'
          + '<div class="cart-line__price">' + formatMoney(item.final_line_price) + '</div>'
          + '</li>';
      });
      html += '</ul>';
      body.innerHTML = html;
    }).catch(function (err) {
      console.error('Cart refresh failed', err);
    });
  }

  // ── Add to cart (AJAX, with guaranteed native fallback) ──
  // Handles both single-item forms (id + quantity) and multi-item bundle
  // forms (items[0][id], items[0][quantity], ...). If anything in the AJAX
  // path fails, the form is submitted natively so the click is never dead.
  function initProductForms() {
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form || form.tagName !== 'FORM') return;
      var action = form.getAttribute('action') || '';
      if (action.indexOf('/cart/add') === -1) return;

      // In the theme editor let the browser submit normally (fetch + cart
      // drawer are unreliable inside the customizer preview).
      if (designMode) return;

      e.preventDefault();

      var submitBtn = form.querySelector('[type="submit"]');
      var original = submitBtn ? submitBtn.innerHTML : '';
      function busy() { if (submitBtn) { submitBtn.disabled = true; submitBtn.setAttribute('aria-busy', 'true'); submitBtn.innerHTML = 'Adding&hellip;'; } }
      function restore() { if (submitBtn) { submitBtn.disabled = false; submitBtn.removeAttribute('aria-busy'); submitBtn.innerHTML = original; } }
      function nativeFallback() { restore(); HTMLFormElement.prototype.submit.call(form); }
      busy();

      var addUrl = (Theme.routes && Theme.routes.cart_add_url) || '/cart/add.js';
      var fd = new FormData(form);

      // Detect the multi-item bundle shape and send it as proper JSON.
      var multi = false;
      fd.forEach(function (_v, k) { if (k.indexOf('items[') === 0) multi = true; });

      var opts;
      if (multi) {
        var map = {};
        fd.forEach(function (val, k) {
          var m = k.match(/^items\[(\d+)\]\[(\w+)\]$/);
          if (!m) return;
          map[m[1]] = map[m[1]] || {};
          map[m[1]][m[2]] = m[2] === 'quantity' ? (parseInt(val, 10) || 1) : val;
        });
        var items = Object.keys(map).sort(function (a, b) { return a - b; }).map(function (i) { return map[i]; });
        if (!items.length) { nativeFallback(); return; }
        opts = {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ items: items })
        };
      } else {
        opts = {
          method: 'POST',
          headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: fd
        };
      }

      fetch(addUrl, opts)
        .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
        .then(function (res) {
          if (!res.ok || (res.data && res.data.status)) {
            var msg = (res.data && (res.data.description || res.data.message))
              || (Theme.strings && Theme.strings.cartError) || 'Could not add to cart';
            showToast(msg);
            restore();
            return;
          }
          showToast(Theme.strings && Theme.strings.addedToCart || 'Added to cart');
          restore();
          renderCartDrawer().then(openCart).catch(function () {});
        })
        .catch(function (err) {
          // Network / parse failure — never leave the customer stuck.
          console.error('[theme.js] AJAX add failed, submitting form natively', err);
          nativeFallback();
        });
    });
  }

  // ── Cart line qty + remove ──
  function initCartLineActions() {
    document.addEventListener('click', function (e) {
      var line = e.target.closest('[data-line-key]');
      if (!line) return;
      var key = line.dataset.lineKey;
      var qtyInput = $('[data-qty]', line);
      var qty = parseInt(qtyInput && qtyInput.value, 10) || 0;

      if (e.target.matches('[data-qty-plus]')) qty += 1;
      else if (e.target.matches('[data-qty-minus]')) qty = Math.max(0, qty - 1);
      else if (e.target.matches('[data-remove]')) qty = 0;
      else return;

      changeCart(key, qty);
    });
  }

  function changeCart(key, qty) {
    if (!Theme.routes) return;
    fetch(Theme.routes.cart_change_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
      .then(function (r) { return r.json(); })
      .then(function () { return renderCartDrawer(); })
      .catch(function (err) { console.error('Change cart failed', err); });
  }

  // ── Variant picker ──
  function initVariantPicker() {
    document.addEventListener('change', function (e) {
      if (!e.target.matches('input[type="radio"][name^="options["]')) return;
      var form = e.target.closest('form');
      if (!form) return;
      var jsonEl = form.querySelector('[data-product-json]');
      if (!jsonEl) return;
      var data;
      try { data = JSON.parse(jsonEl.textContent); } catch (err) { return; }
      if (!data.variants) return;

      var selected = {};
      $$('input[type="radio"]:checked', form).forEach(function (r) {
        var m = r.name.match(/options\[(.+)\]/);
        if (m) selected[m[1]] = r.value;
      });

      var match = data.variants.find(function (v) {
        return v.options.every(function (opt, i) { return opt === selected[data.options[i]]; });
      });
      if (!match) return;

      var vidEl = $('[data-variant-id]', form);
      if (vidEl) vidEl.value = match.id;

      var priceEl = $('[data-product-price]');
      if (priceEl) priceEl.textContent = formatMoney(match.price);

      var btn = form.querySelector('[type="submit"]');
      if (btn) {
        btn.disabled = !match.available;
        btn.innerHTML = match.available ? (btn.dataset.addText || 'Add to cart') : (Theme.strings && Theme.strings.soldOut || 'Sold out');
      }
    });
  }

  // ── PDP quantity stepper ──
  function initQtyStepper(scope) {
    $$('[data-qty-stepper]', scope).forEach(function (stepper) {
      var input = $('[data-qty-input]', stepper.closest('form') || stepper.parentElement);
      var display = $('[data-qty-display]', stepper);
      var decrease = $('[data-qty-decrease]', stepper);
      var increase = $('[data-qty-increase]', stepper);
      if (!input || !display || !decrease || !increase) return;

      function render() {
        display.textContent = input.value;
      }
      function syncTiers() {
        var form = stepper.closest('form');
        if (!form) return;
        var tiers = $$('[data-bundle-qty]', form);
        tiers.forEach(function (t) {
          t.classList.toggle('is-selected', t.dataset.bundleQty === input.value);
        });
      }
      decrease.addEventListener('click', function () {
        input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
        render();
        syncTiers();
      });
      increase.addEventListener('click', function () {
        input.value = (parseInt(input.value, 10) || 1) + 1;
        render();
        syncTiers();
      });
      render();
    });
  }

  // ── PDP bundle tier picker ──
  function initBundleTiers(scope) {
    $$('[data-bundle-tiers]', scope).forEach(function (wrap) {
      var form = wrap.closest('form');
      if (!form) return;
      var input = $('[data-qty-input]', form);
      var display = $('[data-qty-display]', form);
      var tiers = $$('[data-bundle-qty]', wrap);
      if (!input || !tiers.length) return;

      tiers.forEach(function (tier) {
        tier.addEventListener('click', function () {
          var qty = tier.dataset.bundleQty;
          input.value = qty;
          if (display) display.textContent = qty;
          tiers.forEach(function (t) { t.classList.toggle('is-selected', t === tier); });
        });
      });
    });
  }

  // ── PDP gallery dot sync ──
  function initPdpGallery(scope) {
    $$('[data-pdp-gallery]', scope).forEach(function (gallery) {
      var track = $('[data-pdp-gallery-track]', gallery);
      var dots = $$('[data-pdp-dot]', gallery);
      if (!track || !dots.length) return;
      var ticking = false;
      track.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () {
          var idx = Math.round(track.scrollLeft / (track.clientWidth || 1));
          dots.forEach(function (d, i) { d.classList.toggle('active', i === idx); });
          ticking = false;
        });
      });
    });
  }

  // ── Accordions / FAQ ──
  function initAccordions(scope) {
    $$('[data-accordion]', scope).forEach(function (acc) {
      var btn = $('[data-accordion-trigger]', acc);
      var panel = $('[data-accordion-panel]', acc);
      if (!btn || !panel) return;
      btn.addEventListener('click', function () {
        var open = acc.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', String(open));
        panel.hidden = !open;
      });
    });
  }

  // ── Tabs ──
  function initTabs(scope) {
    $$('[data-tabs]', scope).forEach(function (tabs) {
      var triggers = $$('[data-tab-trigger]', tabs);
      var panels = $$('[data-tab-panel]', tabs);
      triggers.forEach(function (t, i) {
        t.addEventListener('click', function () {
          triggers.forEach(function (x) { x.classList.remove('is-active'); x.setAttribute('aria-selected', 'false'); });
          panels.forEach(function (x) { x.hidden = true; });
          t.classList.add('is-active');
          t.setAttribute('aria-selected', 'true');
          if (panels[i]) panels[i].hidden = false;
        });
      });
    });
  }

  // ── Scroll reveal (fade + rise into view, once) ──
  function initReveal(scope) {
    if (!('IntersectionObserver' in window)) return;
    var els = $$('.reveal:not([data-reveal-bound])', scope);
    if (!els.length) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });
    els.forEach(function (el) {
      el.setAttribute('data-reveal-bound', '');
      io.observe(el);
    });
  }

  // ── Init all ──
  // Each init runs in its own try/catch: one section's broken markup must
  // never silently disable every init that runs after it in this list
  // (e.g. a PDP gallery bug should never take down the cart drawer).
  function safe(fn) {
    try {
      fn();
    } catch (err) {
      if (window.console && console.error) {
        console.error('[theme.js] init failed: ' + (fn.name || 'anonymous'), err);
      }
    }
  }

  function initAll(scope) {
    safe(function initMobileMenuSafe() { initMobileMenu(scope); });
    safe(function initCartDrawerEventsSafe() { initCartDrawerEvents(); });
    safe(function initQtyStepperSafe() { initQtyStepper(scope); });
    safe(function initBundleTiersSafe() { initBundleTiers(scope); });
    safe(function initPdpGallerySafe() { initPdpGallery(scope); });
    safe(function initAccordionsSafe() { initAccordions(scope); });
    safe(function initTabsSafe() { initTabs(scope); });
    safe(function initRevealSafe() { initReveal(scope); });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAll(document);
    safe(function initProductFormsSafe() { initProductForms(); });
    safe(function initCartLineActionsSafe() { initCartLineActions(); });
    safe(function initVariantPickerSafe() { initVariantPicker(); });
  });

  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });

})();
